// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 26) return "./default/chunk-html-box-reg-wall.1d17725b054e612d64e6.js";
	if (chunkId === 36) return "./default/chunk-recombee-init.f515e4d4705086120f11.js";
	if (chunkId === 27) return "./default/chunk-lazyload-images.5d4204fe5678bbffbbb1.js";
	if (chunkId === 24) return "./default/chunk-gtm-highlight.4f9382c1d54d5e2a4ab4.js";
	if (chunkId === 34) return "./default/chunk-progressBar.b0486e619887a34d8d95.js";
	if (chunkId === 16) return "./default/chunk-accordion.4bcde3851e31c32421fc.js";
	if (chunkId === 21) return "./default/chunk-fadeInOnEnterViewport.232b6d46506872aab2f6.js";
	if (chunkId === 30) return "./default/chunk-megamenu.530612cf4c6f8a0be7c3.js";
	if (chunkId === 25) return "./default/chunk-header.1ea91b18820cc58fb789.js";
	if (chunkId === 29) return "./default/chunk-mainNavigation.668491119a1f14729edb.js";
	if (chunkId === 31) return "./default/chunk-modal.cd54e8cf76b004ec4c97.js";
	if (chunkId === 68) return "./68.2f07bacd96af312ec9ac.js";
	if (chunkId === 23) return "./default/chunk-gallery.37cbd3d521c30521ae35.js";
	if (chunkId === 20) return "./default/chunk-enquiry.1846a5bf0cb89d95c180.js";
	if (chunkId === 40) return "./default/chunk-survey.6d6b999de9a0ef3c6433.js";
	if (chunkId === 22) return "./default/chunk-forum.0bdaf90c1680791bdcd9.js";
	if (chunkId === 64) return "./64.33f81ac2dcb36e4b5b1d.js";
	if (chunkId === 35) return "./default/chunk-recombee.ec36b7a675888969cdfa.js";
	if (chunkId === 65) return "./65.e764f91397784df76ce6.js";
	if (chunkId === 28) return "./default/chunk-load-more.0e8959e7217cd2e663fd.js";
	if (chunkId === 42) return "./default/chunk-uncover-behav-articles.7665dced92f31d0bf3b0.js";
	if (chunkId === 17) return "./default/chunk-ads-repeater.ab46729f60c1753043b7.js";
	if (chunkId === 49) return "./default/newsletter.5d300820cb83c86126b2.js";
	if (chunkId === 44) return "./default/companySubscription.42f3af84e3ab9860af62.js";
	if (chunkId === 53) return "./default/swiper.f435f532d2cd4096d54a.js";
	if (chunkId === 55) return "./default/thingsArticleSwiper.b9cfc07a78f29c748678.js";
	if (chunkId === 19) return "./default/chunk-editorial-promo.6dcc66d9fc96ddfa59c5.js";
	if (chunkId === 56) return "./default/topic-banner.8d2e6faa0e5ecf5798fc.js";
	if (chunkId === 47) return "./default/instagram.f1306fb2cfdc7269278f.js";
	if (chunkId === 50) return "./default/piano.0e10729680bc6a8410de.js";
	if (chunkId === 66) return "./66.1a44b96cd1dadbf6ff33.js";
	if (chunkId === 51) return "./default/portaInit.0f73298a309e08d9d0b4.js";
	if (chunkId === 48) return "./default/jakebox.a1c47f61eee9bf5f6cad.js";
	if (chunkId === 43) return "./default/collapser.4a53ad302576f7e411c7.js";
	if (chunkId === 15) return "./default/author-card-list.b834ba63388e355e2381.js";
	if (chunkId === 52) return "./default/rename-article-list.3fe5c5e21c5924c965d7.js";
	if (chunkId === 13) return "./chunk-todayResultSliderHP.c93e4cc85f691541b137.js";
	if (chunkId === 7) return "./chunk-previewMatchesListVideoSlider.2d1fcf06cf952bd74663.js";
	if (chunkId === 5) return "./chunk-headermenuflat.f746b58c7b94c3ff5e89.js";
	if (chunkId === 46) return "./default/info-toggle.6eaf7cda90c16ea2276d.js";
	if (chunkId === 54) return "./default/tabs.174108f413df0de52e40.js";
	if (chunkId === 12) return "./chunk-sportmodDayResultDatepicker.e9cd4b49a1737e221ab7.js";
	if (chunkId === 67) return "./67.8718688cdf97edad7fab.js";
	if (chunkId === 9) return "./chunk-sportmod-live-match-websocket-updater.2c6d3abbd8423dab617b.js";
	if (chunkId === 8) return "./chunk-sportmod-league-phase-reloader.cfb17e4672d19471f51a.js";
	if (chunkId === 10) return "./chunk-sportmod-matches-with-table-phase-reloader.6bef949ea08e2b3713b5.js";
	if (chunkId === 11) return "./chunk-sportmod-team-matches-toggle.bf60227f699fbed4add9.js";
	if (chunkId === 4) return "./chunk-category-content-loader.bc775c9f8cde53f3661e.js";
	if (chunkId === 14) return "./chunk-top-feed-responsive-behavior.ec836b6a1c1d01e93a98.js";
	// return url for filenames based on template
	return undefined;
};